import { Grid, Typography } from "@mui/material";
import { AppAlert, LabelAndValue } from "../../../components/form";
import { convertToFullName } from "../../../services/utils";

interface AmbassadorInfoSectionProps {
  ambassador: any;
}

export function AmbassadorInfoSection({
  ambassador,
}: AmbassadorInfoSectionProps) {
  return (
    <Grid container spacing={1.5}>
      <Grid item xs={12}>
        <AppAlert severity="info" sx={{ fontSize: "small" }}>
          <Typography variant="body2">
            Prior to finalizing the dates and times, kindly verify that you
            haven’t previously met with the specified ambassador. This step
            helps avoid last minute meeting cancellations.
          </Typography>
        </AppAlert>
      </Grid>
      <Grid item xs={12} container gap={2}>
        <LabelAndValue
          label="Name:"
          labelWrapperProps={{ xs: 12, sm: 3 }}
          valueWrapperProps={{ xs: 12, sm: 9 }}
          value={convertToFullName(ambassador)}
        />
        <LabelAndValue
          label="Title:"
          labelWrapperProps={{ xs: 12, sm: 3 }}
          valueWrapperProps={{ xs: 12, sm: 9 }}
          value={ambassador?.title}
        />
      </Grid>
      <Grid item xs={12}>
        <LabelAndValue
          label="Company:"
          labelWrapperProps={{ xs: 12, sm: 3 }}
          valueWrapperProps={{ xs: 12, sm: 9 }}
          value={ambassador?.company}
        />
      </Grid>
    </Grid>
  );
}
